import React from 'react';

import { getTranslation } from 'helpers/getTranslation';
import { getStudentPresenceStatus } from 'helpers/getStudentPresenceStatus';

import { Icon } from 'components/shared/Icon';
import { Button } from 'components/shared/Button';
import { Avatar } from 'components/shared/Avatar';
import { Typography } from 'components/shared/Typography';

import styles from './StudentCard.module.scss';

const StudentCard = ({
  avatar,
  name,
  email,
  lastSeenAt,
  onCopyEmailClick,
  onEditClick,
}: {
  avatar: any;
  name: any;
  email: any;
  lastSeenAt: any;
  onCopyEmailClick: any;
  onEditClick: any;
}) => (
  <div className={styles.card}>
    <div className={styles.inner}>
      <Avatar
        url={avatar}
        text={name || email}
        presenceStatus={getStudentPresenceStatus(lastSeenAt)}
      />
      <div className={styles.main}>
        <div className={styles.info}>
          <Typography
            className={styles.name}
            variant="body1"
            weight="medium"
            mode="compact"
          >
            {name || '-'}
          </Typography>
        </div>

        <div className={styles.emailInfo}>
          <Typography className={styles.email} variant="body3" mode="compact">
            {email}
          </Typography>
          <Icon
            className={styles.copyIcon}
            name="copy"
            onClick={onCopyEmailClick}
          />
        </div>
      </div>
    </div>

    <div className={styles.actions}>
      <Button
        className={styles.action}
        startIcon={<Icon name="edit" />}
        size="md"
        variant="outlined"
        onClick={onEditClick}
      >
        {getTranslation('common.button.edit')}
      </Button>
    </div>
  </div>
);

export default React.memo(StudentCard) as any;
